import { render, staticRenderFns } from "./approval-details.vue?vue&type=template&id=16f731fb&"
import script from "./approval-details.vue?vue&type=script&lang=ts&"
export * from "./approval-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports